import React from 'react';
import { IconMenu, MenuItem, IconButton, FontIcon, RaisedButton, TextField, DropDownMenu, Chip } from 'material-ui';
import { JiraFlatButton } from '../../../tc-ui/small-buttons';
import FlatDropDown from '../../../tc-ui/flatDropDownMenu';
import R from 'ramda';
import A from 'aphrodite';
import GroupTemplateIcon from 'material-ui/svg-icons/content/link';
import CalendarIcon from 'material-ui/svg-icons/action/today';
import GroupByNameIcon from 'material-ui/svg-icons/content/font-download';
import { getTemplateStatusColor } from '../../contractingUtils';
import { toLaxTitleCase } from 'titlecase';

const SearchAndFilter = ({
  route,
  updateFilters,
  showType,
  searchInput,
  isSingleLoc,
  statusesFilter,
  updateProps,
}) => {
  const search = () => updateFilters({
    searchInput,
    templateListPage: 1,
    draftListPage: 1,
  });
  const styleSheets = A.StyleSheet.create({
    containerDiv: { borderBottom: '1px solid rgba(0, 0, 0, 0.1)', backgroundColor: 'rgba(0, 0, 0, 0.05)', display: 'flex', flexDirection: 'column', paddingRight: '4px' },
    searchNStatusFilterNButtonsContainerDiv: { display: 'flex', height: '51px' },
    searchDiv: { border: '1px solid #00bcd4', width: '85%', marginLeft: '2%', display: 'flex', borderRadius: '2px', height: '34px', top: '10px', position: 'relative', justifyContent: 'space-between', backgroundColor: 'white' },
    closeIconButton: { padding: '0', height: '34px', top: '4px', display: searchInput ? 'inline-block' : 'none' },
    buttonsDiv: { display: 'flex', height: '36px', position: 'relative', top: '8px', minWidth: '240px', flexDirection: 'row-reverse' },
  });
  return (
    <div className={A.css(styleSheets.containerDiv)}>
      <div className={A.css(styleSheets.searchNStatusFilterNButtonsContainerDiv)}>
        <div className={A.css(styleSheets.searchDiv)}>
          <FlatDropDown
            desktop
            style={{ marginLeft: '8px', cursor: 'pointer' }}
            button={<JiraFlatButton
              style={{ fontSize: '14px', padding: '0', width: '140px', height: '32px' }}
              icon={<FontIcon className="tc-icon-arrow-drop-down" color="rgba(0, 0, 0, 0.75)" style={{ fontSize: '20px' }}/>}
              labelPosition="before"
              label={(() => {
                if (!showType) return toLaxTitleCase(route);
                if (route === 'templates' && showType === 'group') return 'Template Groups';
                if (showType === 'location') return 'Locations';
                if (showType === 'date') return 'Contract Period';
                if (showType === 'templateName') return 'Template Name';
              })()}
            />}
          >
            <MenuItem
              style={{ color: !showType ? '#ff4081' : '' }}
              primaryText="Templates"
              leftIcon={<FontIcon className={`tc-icon-${route === 'drafts' ? 'receipt' : 'description'}`}/>}
              onTouchTap={() => updateFilters({ showType: undefined, searchInput: '' })}
            />
            <MenuItem primaryText="Group By" disabled />
            <MenuItem
              style={{ color: showType === 'group' ? '#ff4081' : '' }}
              primaryText="Template Groups"
              leftIcon={<GroupTemplateIcon/>}
              onTouchTap={() => updateFilters({ showType: 'group', searchInput: '' })}
            />
            {
              !isSingleLoc && (
                <MenuItem
                  style={{ color: showType === 'location' ? '#ff4081' : '' }}
                  primaryText="Locations"
                  leftIcon={<FontIcon className="tc-icon-location_on" />}
                  onTouchTap={() => updateFilters({ showType: 'location', searchInput: '' })}
                />
              )
            }
            <MenuItem
              style={{ color: showType === 'templateName' ? '#ff4081' : '' }}
              primaryText="Template Name"
              leftIcon={<GroupByNameIcon/>}
              onTouchTap={() => updateFilters({ showType: 'templateName', searchInput: '' })}
            />
            <MenuItem
              style={{ color: showType === 'date' ? '#ff4081' : '' }}
              primaryText="Contract Period"
              leftIcon={<CalendarIcon/>}
              onTouchTap={() => updateFilters({ showType: 'date', searchInput: '' })}
            />
          </FlatDropDown>
          <TextField
            hintText={R.call(R.cond([
              [R.equals('location'), R.always(`Search by Location Name...`)],
              [R.equals('group'), R.always(`Search by Group Name...`)],
              [R.T, R.always(`Search by Template Name ${isSingleLoc ? '' : ', Location Name'}...`)],
            ]), showType)}
            inputStyle={{ bottom: '2px' }}
            value={searchInput || ''}
            style={{ width: searchInput ? '60%' : '67%', height: '35px', marginLeft: '8px' }}
            hintStyle={{ bottom: '6px', fontSize: '13px' }}
            underlineShow={false}
            onKeyDown={e => {
              if (e.keyCode === 13) search();
            }}
            onChange={(_, value) => updateFilters({ searchInput: value })}
          />
          <IconButton
            iconClassName="tc-icon-close"
            iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}
            className={A.css(styleSheets.closeIconButton)}
            onTouchTap={() => updateFilters({ searchInput: '', templateListPage: 1, draftListPage: 1 })}
          />
          <RaisedButton
            label="Search"
            style={{ height: '32px', minWidth: '82px', width: '82px' }}
            overlayStyle={{ height: '32px' }}
            buttonStyle={{ height: '32px', lineHeight: '32px' }}
            secondary
            onTouchTap={search}
          />
        </div>
        <DropDownMenu autoWidth value="Template Statuses" underlineStyle={{ borderTopColor: '#00bcd4' }} iconStyle={{ fill: '#00bcd4' }} style={{ top: '-4px' }} >
          {
            ['new draft', 'draft', 'completed', 'archived', 'not sent'].map((status, i) => {
              const foundIndex = R.findIndex(R.equals(status), statusesFilter);
              return (
                <MenuItem
                  key={i}
                  value={status}
                  checked={Boolean(foundIndex > -1)}
                  onTouchTap={() => {
                    const newStatuses = foundIndex > -1 ? R.remove(foundIndex, 1, statusesFilter) : R.append(status, statusesFilter);
                    updateFilters({ statusesFilter: newStatuses });
                  }}
                  style={{ color: getTemplateStatusColor(status) }}
                  primaryText={status}
                />);
            })
          }
          <MenuItem value="Template Statuses" label="Template Statuses" style={{ display: 'none' }} />
        </DropDownMenu>
      </div>
      <div style={{ paddingBottom: '8px', display: statusesFilter && statusesFilter.length ? 'flex' : 'none', marginLeft: '2%' }}>
        {
          (statusesFilter || []).map((status, index) => (
            <Chip
              key={index}
              style={{ marginRight: '8px' }}
              labelColor={getTemplateStatusColor(status)}
              onRequestDelete={() => updateFilters({ statusesFilter: R.remove(index, 1, statusesFilter) })}
            >
              {status}
            </Chip>
          ))
        }
      </div>
    </div>
  );
};

export default SearchAndFilter;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/search-filter.jsx